import React, { createContext, useState } from "react";

export const ToastContext = createContext();
// showToast, toastMessage,variant
export function ToastProvider({ children }) {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [variant, setVariant] = useState("success");
  const [autoHide, setAutoHide] = useState(false);
  const [delay, setDelay] = useState(3000);
  const [isMinimized, setIsMinimized] = useState(false);

  const closeToast = () => {
    setToastMessage("");
    setVariant("success");
    setAutoHide(false);
    setDelay(3000);
    setIsMinimized(false);
    setShowToast(false);
  };

  const toggleMinimize = () => {
    setIsMinimized((prev) => !prev);
  };

  const updateToast = (
    toastConfigOrMessage,
    legacyVariant,
    legacyShowToast = true,
    legacyOptions = {},
  ) => {
    const nextToast =
      toastConfigOrMessage && typeof toastConfigOrMessage === "object"
        ? toastConfigOrMessage
        : {
            message: toastConfigOrMessage,
            variant: legacyVariant,
            showToast: legacyShowToast,
            ...legacyOptions,
          };

    setToastMessage(nextToast.message || "");
    setVariant(nextToast.variant || "success");
    setAutoHide(Boolean(nextToast.autoHide));
    setDelay(nextToast.delay || 3000);
    setShowToast(Boolean(nextToast.showToast));
  };

  return (
    <ToastContext.Provider
      value={{
        showToast,
        toastMessage,
        variant,
        autoHide,
        delay,
        isMinimized,
        updateToast,
        closeToast,
        toggleMinimize,
        setShowToast,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
}
